import { PaletteOptions } from '@mui/material';
import { ControllerThemeColor } from './colors';

export * from './colors';

const palette: PaletteOptions = {
  background: {
    default: String(ControllerThemeColor.BackgroundDefault),
    paper: String(ControllerThemeColor.BackgroundPaper),
  },
  divider: String(ControllerThemeColor.Divider),
  error: {
    dark: String(ControllerThemeColor.DangerDark),
    light: String(ControllerThemeColor.DangerLight),
    main: String(ControllerThemeColor.DangerMain),
  },
  grey: {
    '50': String(ControllerThemeColor.Gray50),
    '100': String(ControllerThemeColor.Gray100),
    '200': String(ControllerThemeColor.Gray200),
    '400': String(ControllerThemeColor.Gray400),
    '600': String(ControllerThemeColor.Gray600),
    '700': String(ControllerThemeColor.Gray700),
    '800': String(ControllerThemeColor.Gray800),
    '900': String(ControllerThemeColor.Gray900),
  },
  info: {
    dark: String(ControllerThemeColor.InfoDark),
    light: String(ControllerThemeColor.InfoLight),
    main: String(ControllerThemeColor.InfoMain),
  },
  primary: {
    dark: String(ControllerThemeColor.PrimaryDark),
    light: String(ControllerThemeColor.PrimaryLight),
    main: String(ControllerThemeColor.PrimaryMain),
  },
  secondary: {
    dark: String(ControllerThemeColor.SecondaryDark),
    light: String(ControllerThemeColor.SecondaryLight),
    main: String(ControllerThemeColor.SecondaryMain),
  },
  success: {
    dark: String(ControllerThemeColor.SuccessDark),
    light: String(ControllerThemeColor.SuccessLight),
    main: String(ControllerThemeColor.SuccessMain),
  },
  text: {
    disabled: String(ControllerThemeColor.TextDisabled),
    primary: String(ControllerThemeColor.TextPrimary),
    secondary: String(ControllerThemeColor.TextSecondary),
  },
  warning: {
    dark: String(ControllerThemeColor.WarningMain),
    light: String(ControllerThemeColor.WarningLight),
    main: String(ControllerThemeColor.WarningMain),
  },
};

export default palette;
